import {Component, OnInit} from '@angular/core';
import {AuthenticationService, BaseComponent, Environment} from '@enerbim/commons-lib';
import {environment} from '../environments/environment';
import {StateStorageService} from 'app/shared/service/state-storage.service';
import {filter, takeUntil} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {AppStore} from 'app/shared/store/app.store';
import {Observable} from 'rxjs';
import {LoginDialogService} from 'app/shared/service/login-dialog.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.scss']
})
export class AppComponent extends BaseComponent implements OnInit {

    /** Montrer le spinner de chargement de l'application ? */
    showGlobalSpinner$: Observable<string>;

    constructor(
        private authenticationService: AuthenticationService,
        private stateStorageService: StateStorageService,
        private loginDialogService: LoginDialogService,
        private router: Router,
        private appStore: AppStore,
    ) {
        super();
    }

    ngOnInit() {
        // Renseigne les paramètres d'environnement dans la librairie "angular-commons"
        Environment.apiUrl = environment.apiUrl;
        Environment.managementUrl = environment.managementUrl;
        Environment.swaggerUrl = environment.swaggerUrl;
        Environment.defaultLandingPage = '';
        Environment.appName = "CN-BIM";
        Environment.appVersion = environment.appVersion;

        // Initialise l'utilisateur courant
        this.authenticationService.queryAndSetCurrentUser().subscribe();

        // Stocke les URLs quand on navigue (pour pouvoir rediriger après login)
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this.ngUnsubscribe)
        ).subscribe(() => {
            this.stateStorageService.storeUrl(this.router.url);
        });

        // Spinner ?
        this.showGlobalSpinner$ = this.appStore.getGlobalSpinner();

    }

}
